import { ChangeDetectorRef, Component, inject, input } from '@angular/core';
import { Image, ImageModule } from 'primeng/image';
import { firstValueFrom } from 'rxjs';

import { StorageObjectDto } from '../api/backend-connector/models';
import { ButtonDirective } from '../directives/button.directive';
import { AttachmentsService } from '../services/attachments.service';

@Component({
  selector: 'app-image-preview',
  standalone: true,
  imports: [ImageModule, ButtonDirective],
  templateUrl: './image-preview.component.html',
  styleUrl: './image-preview.component.scss',
})
export class ImagePreviewComponent {
  private readonly attachmentsService = inject(AttachmentsService);
  readonly src = input.required<{ type: 'dto'; value: StorageObjectDto } | { type: 'objectURL'; value: string }>();

  async preview(image: Image) {
    const src = this.src();
    if (src.type === 'objectURL') {
      image.previewImageSrc = src.value;
    } else {
      const blob = await firstValueFrom(this.attachmentsService.downloadFile({ id: src.value.id }));
      image.previewImageSrc = URL.createObjectURL(blob);
    }
    image.onImageClick();
    (image as unknown as { cd: ChangeDetectorRef }).cd.markForCheck();
  }
}
